import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColor, IconSize } from '@widgets/eop-icon/eop-icon.component';

export enum HighLightedColor {
  NONE = 'none',
  INFO = 'info',
  WARNING = 'warning',
}

export interface QuickAccessEntry {
  label: string;
  icon: string;
  tooltip?: string;
}

@Component({
  selector: 'eop-quick-access-entry',
  templateUrl: './quick-access-entry.component.html',
  styleUrls: ['./quick-access-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QuickAccessEntryComponent {
  readonly IconSize = IconSize;
  readonly IconColor = IconColor;

  @Input()
  entry: QuickAccessEntry;

  @Input()
  additionalEntries: QuickAccessEntry[] = [];

  @Input()
  isSelected: boolean;

  @Input()
  disabled: boolean;

  @Input()
  highlightedColor: HighLightedColor = HighLightedColor.NONE;

  @Input()
  compact: boolean;
}
